var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5001,
    cy: 10.0002,
    r: 7.68333,
    stroke: "#708185",
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0946 11.6665H9.90508C9.82452 11.6665 9.75482 11.6965 9.69594 11.7565C9.63711 11.8165 9.60767 11.8874 9.60767 11.9695V13.0301C9.60767 13.1122 9.63711 13.1832 9.69594 13.2433C9.75487 13.3031 9.82451 13.3332 9.90508 13.3332H11.0947C11.1751 13.3332 11.2449 13.3031 11.3038 13.2433C11.3625 13.1832 11.392 13.1122 11.392 13.0301V11.9695C11.392 11.8875 11.3625 11.8165 11.3037 11.7565C11.2448 11.6965 11.1751 11.6665 11.0946 11.6665Z",
    fill: "#708185"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.45 6.75662C11.3927 6.69672 11.3238 6.66667 11.2432 6.66667H9.75636C9.67583 6.66667 9.60696 6.69672 9.54962 6.75662C9.49232 6.81661 9.46522 6.88767 9.46832 6.96972L9.59838 10.606C9.60147 10.688 9.63319 10.7591 9.69362 10.819C9.75401 10.8791 9.82448 10.9091 9.90504 10.9091H11.0947C11.1751 10.9091 11.2455 10.8791 11.3061 10.819C11.3665 10.7591 11.3981 10.688 11.4013 10.606L11.5313 6.96972C11.5345 6.88767 11.5073 6.81667 11.45 6.75662Z",
    fill: "#708185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarningIcon);
export default __webpack_public_path__ + "static/media/ic_warning_icon.8b309cdac0302996f47da6120fdcf3f9.svg";
export { ForwardRef as ReactComponent };